import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import OurStory from './pages/OurStory';
import Travel from './pages/Travel';
import Schedule from './pages/Schedule';
import Registry from './pages/Registry';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SEOProvider } from './components/SEO';
import RSVP from './pages/RSVP';
import Dashboard from './pages/Dashboard';
import SEO from './pages/SEO';

// Protected route component - only for RSVP page
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/seo" element={<SEO />} />
      <Route path="/our-story" element={<OurStory />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/travel" element={<Travel />} />
      <Route path="/rsvp" element={
        <ProtectedRoute>
          <RSVP />
        </ProtectedRoute>
      } />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/registry" element={<Registry />} />
      {/* Catch all route - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <SEOProvider>
        <Router>
          <Layout>
            <AppRoutes />
          </Layout>
        </Router>
      </SEOProvider>
    </AuthProvider>
  );
}

export default App;
